export default {
    alert: { code: 'code', message: 'message' },
    field: { code: 'trackingCode', message: null },
    form: { code: 'trackingCode', message: 'errorDetail' },
    server: { code: 'code', message: 'message' }
};
